import styled from 'styled-components';

const Container = styled.div`
  margin: 10px 0;
  flex-shrink: 0;
`;

export default Container;
